import { apiSlice } from "../../app/api/apiSlice"
// import { Overview } from "../../components/models/ToDoList"

export const toDoListApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getToDoList: builder.query<void, void>({
            query: (date) => ({
                url:`/Cube/overview?date=${date}`,
                responseHandler: 'json'
            })
        }),
    })
})

export const {
    // useGetUsersQuery,
    useLazyGetToDoListQuery
} = toDoListApiSlice  